// Module
var code = "<td data-bind=\"css: { invalidConsequenceResult: !isValid && !isNaN}\">\r\n    <span data-bind=\"text: valueText\"></span>\r\n    <!-- ko if: !isNaN && !isValid-->\r\n    <span class=\"icon iconHelp blue pointercursor\" data-bind=\"click: toggleHelpTooltip, clickOutside: hideHelpTooltip\"></span>\r\n    <!-- /ko -->\r\n</td>\r\n";
// Exports
module.exports = code;